import { useQuery } from "@tanstack/react-query";
import {
  PaygapSettingsDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_PAYGAP } from "../domain";

import { paygapApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_PAYGAP_SETTINGS = "GET_PAYGAP_SETTINGS";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getPaygapSettings = async (): Promise<PaygapSettingsDto> => {
  const response = await paygapApi.paygapControllerGetSettings();

  return response.data;
};

export const useGetPaygapSettings = (
  user: UserProfileDto | null,
  enabledOverride?: boolean,
): {
  settings: PaygapSettingsDto | undefined;
  getPaygapSettingsEnabled: boolean;
  getPaygapSettingsError: Error | null;
  refetchPaygapSettings: () => Promise<{ data: PaygapSettingsDto | undefined }>;
  isLoadingPaygapSettings: boolean;
  isFetchingPaygapSettings: boolean;
  isSuccessPaygapSettings: boolean;
} => {
  const roleEnabled = roleGuard(user, allowedRoles);
  const enabled = enabledOverride !== undefined ? enabledOverride : roleEnabled;

  const queryResult = useQuery<PaygapSettingsDto, Error>({
    queryKey: [DOMAIN_PAYGAP, ACTION_GET_PAYGAP_SETTINGS],
    queryFn: getPaygapSettings,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    settings: queryResult.data,
    getPaygapSettingsEnabled: enabled,
    getPaygapSettingsError: queryResult.error,
    refetchPaygapSettings: queryResult.refetch,
    isLoadingPaygapSettings: queryResult.isLoading,
    isFetchingPaygapSettings: queryResult.isFetching,
    isSuccessPaygapSettings: queryResult.isSuccess,
  };
};
